
























































import { Vue, Component } from 'vue-property-decorator';
import {
    makeToast,
    MSG_BIP, MSG_CARD_SEC,
    MSG_FIELD, MSG_SMS,
    postData,
    prepareGipData,
    trMsg
} from "@/modules/budget/bip/bip-types";


@Component({
    name: 'modal-gip'
})
export default class ModalGip extends Vue {

    private MSG_BIP = MSG_BIP;
    private showModal = false;
    private tableItems: any[] = [];
    private totalCount = 0;
    private approvedCount = 0;
    private location: any = {}

    get tableFields() {

        return [
            {
                key: "ingip",
                label: trMsg(this, MSG_FIELD + 'gip_code'),
                sortable: true
            },
            {
                key: 'sum',
                label: 'Поддержанная сумма, ' + trMsg(this, MSG_CARD_SEC + '1.thousand_tg')
            },
            {
                key: 'approved',
                label: 'Готовность к отправке'
            }
        ];
    }

    private async showEvent(codes: any[], year: number, location: any) {
        this.tableItems = [];
        const params = {
            'gipCodes': codes,
            'year': year
        }

        this.location = location;

        const response = await postData('/api-py/get-gip-tree/', params) as Map<string, any>;

        // Обработка
        for (const [key, value] of Object.entries(response)) {
            if (value) {
                this.tableItems.push({
                    ingip: key,
                    sum: value.sum,
                    approved: value.approved,
                    finSourceCode: value.funding,
                    source: value.source,
                    funding_mixed: value.funding === '5' ? value.funding_mixed : []
                })
            }
        }
        this.totalCount = this.tableItems.length;
        this.approvedCount = this.tableItems.filter(item => item.approved).length;
        console.log('modalGip', response, this.tableItems)

        this.showModal = true;
    }

    private async send() {
        try {
            // 1. Подготавливаем данные
            const requestBody = prepareGipData(this.tableItems.filter(item => item.approved));

            console.log('📦 Отправляемые данные:', JSON.stringify(requestBody, null, 2));

            // 3. Отправляем запрос
            const response = await fetch('/api-py/send-gip-datas/' + this.location.code, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            // 4. Логируем ответ
            // console.log('response:', response);

            // 5. Получаем тело ответа
            const respText = JSON.parse(await response.text());

            if (response.status == 200) {
                const { success, errors } = respText.data

                // Случай 1: Все успешно
                if (success) {
                    makeToast(this, 'success',
                        trMsg(this, MSG_SMS + 'message'),
                        'Данные по всем проектам успешно переданы')

                    // Обработка данных...
                    return
                }

                // Случай 2: Частичный успех (без детальных ошибок)
                if (!success && (!errors || errors.length === 0)) {
                    makeToast(this, 'success',
                        trMsg(this, MSG_SMS + 'message'),
                        'Данные по проектам частично переданы')
                    return
                }

                // Случай 3: Есть ошибки по конкретным ГИП
                if (!success && errors && errors.length > 0) {
                    // Сначала показываем общее сообщение о частичном успехе
                    makeToast(this, 'success',
                        trMsg(this, MSG_SMS + 'message'),
                        'Данные по проектам частично переданы')

                    // Затем показываем предупреждения по каждому ошибочному ГИП
                    errors.forEach((info: any) => {
                        // Проверяем код ошибки (400, 404, 409)
                        if ([400, 404, 409].includes(Number(info.code))) {
                            makeToast(this, 'warning',
                                `ИНГИП ${info.ingip}`,
                                info.description)
                        }
                    })
                }

            } else if (response.status == 500) {
                // Случай 4: Внутренняя ошибка сервера
                const errorInfo = respText.data?.errors?.[0] || {}
                makeToast(this, 'error',
                    `ИНГИП ${errorInfo.ingip || ''}`,
                    errorInfo.description || 'Внутренняя ошибка сервера ИС ГП')
            }
        } catch (error) {
            makeToast(this, "danger",
                trMsg(this, MSG_SMS + 'error_request'), error.toString());
            alert('Не удалось отправить данные');
        }
    }

    // translate messages
    private trMsg(field: string) {
        return trMsg(this, field);
    }
}
